import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TractorViewModel, TractorStatus } from "@app/shared/models/tractors/TractorViewModel.model";

@Component({
  selector: "app-tractor-maintenance",
  templateUrl: "./tractor-maintenance.component.html",
  styleUrls: ["./tractor-maintenance.component.css"],
})
export class TractorMaintenanceComponent implements OnInit, OnChanges {
  @Input() tractor: TractorViewModel;
  @Input() isEditMode: boolean;
  @Input() dateInputMask: any;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTractor: string;
  TractorStatus = TractorStatus;
  tractorStatusOptions = [
    { value: TractorStatus.Available, label: "Available" },
    { value: TractorStatus.Shop, label: "Shop" },
    { value: TractorStatus.OOS, label: "OOS" }
  ];

  constructor() {}

  ngOnInit() {
    this.originalTractor = JSON.stringify(this.tractor);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["tractor"] && !changes["tractor"].firstChange) {
      this.originalTractor = JSON.stringify(this.tractor);
      this.checkForChanges();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentTractor = JSON.stringify(this.tractor);
    const changed = currentTractor !== this.originalTractor;
    this.hasChanges.emit(changed);
  }

  getTractorStatusLabel(): string {
    if (this.tractor?.status === undefined || this.tractor?.status === null) {
      return "Available";
    }
    const status = this.tractorStatusOptions.find(opt => opt.value === this.tractor.status);
    return status ? status.label : "Available";
  }

  getStatusPillClass(): string {
    if (this.tractor?.status === undefined || this.tractor?.status === null) {
      return "status-pill status-in-service";
    }
    if (this.tractor.status === TractorStatus.Available) {
      return "status-pill status-in-service";
    } else if (this.tractor.status === TractorStatus.Shop) {
      return "status-pill status-out-of-service";
    } else if (this.tractor.status === TractorStatus.OOS) {
      return "status-pill status-out-of-service";
    }
    return "status-pill status-in-service";
  }
}

